import type { FaqContentBlock, FaqContentInline, FaqListItem } from 'shared/types/faq';
import * as styles from './styles.css';
import { TDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';

interface IInlineElementProps {
  inline: FaqContentInline;
}

const renderListItem = (item: FaqListItem, index: number) => {
  const text = typeof item === 'string' ? item : item.text;
  const subItems = typeof item === 'object' ? item.subItems : undefined;

  return (
    <li key={index}>
      {text}
      {subItems?.length ? (
        <ol className={styles['letter-list']} type="a">
          {subItems.map((sub, subIndex) => (
            <li key={subIndex}>{sub}</li>
          ))}
        </ol>
      ) : null}
    </li>
  );
};

const InlineElement: React.FC<IInlineElementProps> = ({ inline }) => {
  if (inline.type === 'list') {
    return (
      <ul className={styles['list']}>
        {inline.items.map((listItem, listIndex) => renderListItem(listItem, listIndex))}
      </ul>
    );
  }

  if (inline.type === 'orderedList') {
    return (
      <ol className={styles['ordered-list']}>
        {inline.items.map((listItem, listIndex) => renderListItem(listItem, listIndex))}
      </ol>
    );
  }

  if (inline.type === 'link') {
    return (
      <a href={inline.href} className={styles['link']}>
        {inline.value}
      </a>
    );
  }

  return <span>{inline.value}</span>;
};

interface IFaqItemProps {
  device: TDeviceType;
  content: FaqContentBlock[];
}

export const FaqItem: React.FC<IFaqItemProps> = ({ content, device }) => {
  return (
    <div className={clsx(styles['row'], styles[device])}>
      {content.map((block, blockIndex) => (
        <div key={blockIndex}>
          {block.map((inline, inlineIndex) => (
            <InlineElement key={inlineIndex} inline={inline} />
          ))}
        </div>
      ))}
    </div>
  );
};
